<template>
  <section v-if="homeData" id="home" >
    <Header />
    <div  class="main">
      <Category />
      <template v-if="homeData.local_books.length>0">
    
        <InfoNavigation :config="local"   />
      <Slider :sliderData="homeData.local_books" />
      
      </template>
      <InfoNavigation :config="newBook"   />
      <Slider :sliderData="homeData.latest_books" />
      <InfoNavigation :config="mostVisited"   />
      <Slider :sliderData="homeData.most_visited_books" />
    <template v-for="slider in homeData.book_sliders" >
      <Banner :image="slider.banner" :link="slider.banner_link" :key="slider.id+'b'" />
      <InfoNavigation :config="{title:slider.title,summary:slider.summary,route:''}" :key="slider.id+'i'" />
      <Slider :sliderData="slider.active_books" :key="slider.id+'s'"/>
    </template>
    <PublisherWriter :publishers="homeData.special_publishers" :authors="homeData.special_authors" />
    </div>
  </section>
</template>
<script>
import PublisherWriter  from "../components/home/publisherWriter.vue"
import Header from "../components/home/header.vue";
import Category from "../components/home/category.vue";
import InfoNavigation from "../components/home/infoNavigation.vue";
import Banner from "../components/home/banner.vue"
import Slider from "../components/home/slider.vue"
export default {
  components: {
    PublisherWriter,
    Header,
    Category,
    InfoNavigation,
    Banner,Slider
  },
  created(){
    if(this.homeData==null){
      this.$store.dispatch("getHomeDataFromServer");
    }
  },
  computed:{
    homeData(){
      return this.$store.getters.getHomeData;
    }
  },
  data(){
    return{
      newBook:{
        title:"تازه های کتابخانه",
        summary:"تازه ترین کتاب بانک را در این قسمت مشاهده کنین",
        route:"/book-list?latest=1"
      },
       local:{
        title:"کتابخانه گلستان شناسی",
        summary:"منابع شناخت سرزمین جرجان و استرآباد ",
        route:"/book-list?local=1"
      },
       mostVisited:{
        title:"پربازدیدترین کتاب ها",
        summary:"پربازدید ترین کتاب بانک را در این قسمت مشاهده کنین",
        route:"/book-list?most_popular=1"
      },
    }
  },
     metaInfo() {
    return {
      title: "صفحه اصلی",
      meta: [
        {
          name: "description",
          content:
            "صفحه اصلی بانک کتاب میرداماد"
        },
        {
          property: "og:title",
          content:"صفحه اصلی"
        },
        { name: "robots", content: "index,follow" }
      ]
    };
  }
};
</script>
